export enum RelationStatusEnum {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
}
